import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import FundsContext from './context';
import { Container } from '../../shared/styles';
import Loading from '../../../../shared/loading';
import Header from './import-modal-components/header';
import Fund from './import-modal-components/fund';
import { useSearchFundsToImport } from '../../../../services/lwadmin/fund/fund-service';

const Article = styled.article`
  display: flex;
  flex-direction: column;
  width: 1100px !important;
`;

const SearchText = styled.span`
  text-transform: uppercase;
  font-size: 14px;
  line-height: 120%;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
`;

const Form = styled(Container)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  & > *:first-child {
    margin-right: 20px;
   }
   margin-bottom: 68px;
`;

const Input = styled.input`
   height: 42px !important;
`;

const Button = styled.button`
  text-transform: uppercase;
  font-size: 14px;
  line-height: 120%;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
  color: #fff;
  border: 1px solid #C19D3F;
  background-color: ${props => props.theme.btnPrimaryBackgroundColor};
  border-radius: 2px;
  height: 42px;
  width: 147px;
`;

const NotFoundText = styled.span`
  font-size: 16px;
  line-height: 120%;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightHeavy};
`;

/* eslint-disable complexity */
export default function ImportModal() {
  const {
    state: { showImportModal },
    dispatch,
  } = React.useContext(FundsContext);

  const [errors, setErrors] = React.useState({});
  const [{ data, loading }, find] = useSearchFundsToImport();
  const [funds, setFunds] = React.useState([]);
  const [value, setValue] = React.useState('');

  const overlayRef = React.useRef();
  const modalRef = React.useRef();
  const loadingRef = React.useRef();
  const inputRef = React.useRef();

  const dismiss = e => {
    e && e.preventDefault();
    setErrors({});
    dispatch({ type: 'dismissImportModal' });
  };

  const modalDismiss = e => {
    e && e.preventDefault();
    setErrors({});
    e.target === modalRef.current && dismiss();
  };

  const handleInputChange = e => {
    e && e.preventDefault();
    setErrors({});
    setValue(e.target.value);
  };

  const handleSearch = e => {
    e && e.preventDefault();

    value && find(value);
  };

  const onKeyDown = e => {
    if (e.key === 'Enter' && !loading) {
      handleSearch(e);
    }
  };

  React.useEffect(() => {
    if (showImportModal) {
      $(modalRef.current).fadeIn();
      $(overlayRef.current).fadeIn();
      inputRef.current.focus();
    } else {
      $(overlayRef.current).fadeOut();
      $(modalRef.current).fadeOut({ complete: () => dispatch({ type: 'dismissImportModal' }) });
    }
  }, [showImportModal, dispatch]);

  React.useEffect(() => {
    setFunds(_.get(data, 'funds', []));
  }, [data]);

  React.useEffect(() => (loadingRef.current.toggle(loading)), [loading]);

  return (
    <div>
      <div className="modal-overlay" role="region" ref={overlayRef} onClick={dismiss} />
      <div className="modal --large" tabIndex="-1" role="dialog" ref={modalRef} onClick={modalDismiss}>
        <Article>
          <SearchText>Search for a fund to import data</SearchText>
          <Form className={`form-group ${errors.search && 'has-error'}`}>
            <Input
              ref={inputRef}
              id="search"
              type="text"
              name="search"
              value={value}
              onChange={handleInputChange}
              onKeyDown={onKeyDown}
              placeholder="Enter the fund name or Data Provider ID or ISIN or APIR or Ticker (Stock Code)"
            />
            {errors.search && <span className="help-block">{errors.search}</span>}
            <Button onClick={handleSearch} disabled={loading}>search</Button>
          </Form>
          <Header />
          <Loading ref={loadingRef}>
            {funds.length > 0 && funds.map(fund => <Fund key={fund.dpFundName} fund={fund} />)}
            {data && funds.length === 0 && <NotFoundText>No funds found</NotFoundText>}
          </Loading>
        </Article>
      </div>
    </div>
  );
}
/* eslint-enable complexity */
